/**
 * Single-letter entity state codes returned by the MP API for subscriptions,
 * addons, datasets, workspaces, users and support packages.
 *
 * The string values are the backend wire contract and must not be changed.
 */
export enum EntityState {
    ACTIVE = 'A',
    INACTIVE = 'I',
    ARCHIVED = 'X',
}
